import React from 'react';
import heroBg from '../../../Assets/Images/instructor-tutor-bg.jpg';

const HeroBanner = () => (
  <div className="relative w-full overflow-hidden rounded-[8px] h-[120px] md:h-auto">
    <img src={heroBg} alt="" className="w-full h-full md:h-auto object-cover" />
    <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
      <p
        className="font-pretendard text-white font-normal text-center leading-tight"
        style={{ fontSize: 'clamp(14px, 2vw, 24px)' }}
      >
        실제 업계 현직자들로 구성된 엔터잡에듀 강사진이
      </p>
      <p
        className="font-pretendard text-white font-normal text-center leading-tight mt-1 md:mt-3"
        style={{ fontSize: 'clamp(18px, 3.33vw, 40px)' }}
      >
        <strong>검증된 커리어</strong>로 <strong>차별화된 강의</strong>를 약속드립니다.
      </p>
    </div>
  </div>
);

export default HeroBanner;
